import { isNetworkConnectionError as isNetworkConnectionApiError } from '@/features/api/utils'
import { useToast } from '@/features/common/components/Toast/contexts/Provider'
import { isNetworkConnectionError as isNetworkConnectionApolloError } from '@/features/graphql/utils'
import { logger as baseLogger } from '@/logger'
import { ILogLayer } from 'loglayer'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

export const useHandleErrorWithToast = (logger?: ILogLayer): ((e: unknown) => Promise<void>) => {
    const { show } = useToast()

    const { t } = useTranslation()

    return useCallback(
        async (e: unknown) => {
            const noNetworkConnection =
                isNetworkConnectionApiError(e) || isNetworkConnectionApolloError(e)

            const message = noNetworkConnection
                ? 'errors.missingNetworkConnection'
                : 'unexpectedError'

            show(t('errors.errorHappenedTitle'), t(message))

            if (noNetworkConnection) return

            const actualLogger = logger ?? baseLogger

            actualLogger.errorOnly(e)
        },
        [show, t, logger]
    )
}
